import {
  AfterViewInit,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  ElementRef,
  inject,
  NgZone,
  OnDestroy,
  PLATFORM_ID,
  ViewChild,
  HostListener,
  ChangeDetectorRef,Renderer2
} from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { EmptyContentComponent } from '../editor/additional/placeholders/empty-content.component';
import { registerErrorSpanBlot } from '../editor/additional/custom-blots';
import { IconsComponent } from '../editor/additional/icons/icons.component';
import { ApidataService } from '../apidata.service';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { ModalComponent } from '../editor/additional/modals/modal.component';
import { UploadFileFreeToolsComponent } from '../upload-file-free-tools/upload-file-free-tools.component';
import { MetaTagService } from '../meta-tag.service';
import { environment, GINConstants } from '../../environments/environments';
import { IconsFreeToolsComponent } from '../icons-free-tools/icons-free-tools.component';
import { FormsModule } from '@angular/forms';
import { HeaderComponent } from '../header/header.component';
import { Router, NavigationEnd } from '@angular/router';
import { ArticalComponent } from '../artical/artical.component';
import Quill from 'quill';
import r from '../g-disable';

@Component({
  selector: 'app-article-free-tool',
  standalone: true,
  imports: [
    CommonModule,
    ModalComponent,
    FormsModule,
    UploadFileFreeToolsComponent,
    IconsFreeToolsComponent,
    HeaderComponent,
    ArticalComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './article-free-tool.component.html',
  styleUrl: './article-free-tool.component.css',
})
export class ArticleFreeToolComponent implements AfterViewInit, OnDestroy {
  @ViewChild('editor', { static: true }) editorElement!: ElementRef;
  @ViewChild('editorToolbar', { static: true }) toolbarElement!: ElementRef;

  private platformId = inject(PLATFORM_ID);
  private ngZone = inject(NgZone);

  private articleRequestSignal$ = new Subject<void>();

  Object = Object;

  authLimits = {
    guest: {
      words: 1000,
    },
    auth: {
      words: 1000,
    },
    pro: {
      words: 10000,
    },
  };
  authTitle: string;
  authState: 'guest' | 'auth' | 'pro' = 'auth';

  doc_id: string;

  profile_id = localStorage.getItem('profile_id') || '1';

  openMenu: HTMLElement | null = null;

  quillEditor: any;

  editorEnabled: boolean = true;
  editorLoaded: boolean = false;

  popup = {
    content: [],
    el: null,
    x: 0,
    y: 0,
  };

  modes = ['standard', 'shorten', 'fluency', 'academic', 'simple', 'formal'];

  editorState = {
    words: 0,
    characters: 0,
    res_words: 0,
    res_characters: 0,
    state: 'initial',
    mode: 'standard',
    response: null,
  };

  languages: Record<string, { icon: string; name: string }> = {
    'en-us': {
      icon: 'americanFlag',
      name: 'English US',
    },
    'en-gb': {
      icon: 'britishFlag',
      name: 'English UK',
    },
    'en-ca': {
      icon: 'canadianFlag',
      name: 'English CAN',
    },
    'en-au': {
      icon: 'australianFlag',
      name: 'English AUS',
    },
    'en-in': {
      icon: 'indiaFlag',
      name: 'English IND',
    },
    de: {
      icon: 'germanFlag',
      name: 'German',
    },
  };
  selectedLanguage: keyof typeof this.languages = 'en-us';
  iconRequireReattachment = false;

  constructor(
    private apiDataService: ApidataService,
    private route: ActivatedRoute,
    private metaService: MetaTagService,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private renderer: Renderer2
  ) {
    //
  }

  ngAfterViewInit() {
  
    this.loadEditor();

    this.route.queryParams.subscribe((params) => {
      this.doc_id = params['doc'];
    });

    if (isPlatformBrowser(this.platformId)) {
      r();

      if (this.profile_id !== '1') {
        this.apiDataService
          .getUserProfileContents(this.profile_id)
          .subscribe((data) => {
            this.authTitle = data.contents[0][5];
            if (
              data.contents[0][5] === 'premium_user' ||
              data.contents[0][5] === 'free_trial'
            ) {
              this.authState = 'pro';
              console.log('run pro');
            } else {
              this.authState = 'auth';
              console.log('run auth');
            }
          });
      } else {
        this.authState = 'guest';
      }

      setTimeout(() => {
        if (
          localStorage.getItem('editorValueAI') &&
          localStorage.getItem('editorValueAI') !== '<p><br></p>'
        ) {
          const content = new DOMParser()
            .parseFromString(localStorage.getItem('editorValueAI'), 'text/html')
            .body.textContent.trim();
          if (content.length) {
            this.quillEditor.root.innerHTML =
              localStorage.getItem('editorValueAI');

            setTimeout(() => {
              this.rewrite();
            }, 0);
          } else {
            this.editorEnabled = false;
          }
          localStorage.removeItem('editorValueAI');
        } else {
          this.editorEnabled = false;
          this.apiDataService
            .onloadcontentresquest(
              localStorage.getItem('profile_id') || '1',
              this.doc_id
            )
            .subscribe((data) => {
              const content = new DOMParser()
                .parseFromString(data.outConts, 'text/html')
                .body.textContent.trim();
              if (content.length) {
                this.quillEditor.root.innerHTML = data.outConts;
                this.editorEnabled = true;
              }
            });
        }
      }, 100);
    }
   
  }

  ngOnDestroy() {
    this.articleRequestSignal$.next();
  }

  private loadEditor() {
    if (isPlatformBrowser(this.platformId)) {
      this.ngZone.runOutsideAngular(() => {
        import('ngx-quill').then((module) => {
          import('quill').then((quillModule) => {
            this.ngZone.run(() => {
              this.initializeEditor(module, quillModule);
            });
          });
        });
      });

      document.addEventListener('click', this.handleClickOutside);
    }
  }

  rewrite() {
    if (this.editorState.words > this.authLimits[this.authState].words) {
      document.getElementById(
        'content-exceeds-words-limit-modal'
      ).style.display = 'grid';
      this.quillEditor.enable();
      return;
    }

    this.editorState.state = 'loading';

    this.apiDataService
      .articleapi(this.quillEditor.getText(), this.articleRequestSignal$)
      .subscribe((data) => {
        this.editorState.response = data['updated_content'];
        this.editorState.state = 'initial';
        setTimeout(() => {
          document.getElementById('HTPD2M2708').innerHTML =
            data['updated_content'];
          this.computeWordsAndCharactersCountForRewrite();
          this.saveEditorText();
        }, 0);
      });
  }

  private initializeEditor(quillModule: any, quillImport: any) {
    const Quill = quillImport.default;
    registerErrorSpanBlot(Quill);
    this.editorLoaded = true;

    const editorConfig = {
      modules: {
        toolbar: {
          container: this.toolbarElement.nativeElement,
        },
      },
      placeholder: '',
      theme: 'snow',
    };

    this.quillEditor = new Quill(
      this.editorElement.nativeElement,
      editorConfig
    );

    this.quillEditor.root.id = 'mm';

    this.addEventListeners();
  }
 
  private addEventListeners() {
    if (!this.quillEditor) return;
  
    const q = this.quillEditor;
  
  
    q.on('text-change', () => {
      this.editorEnabled = true;
      this.computeWordsAndCharactersCount();
      this.count_Words_Character2();
      this.showParagraph = false;
    });

    q.root.addEventListener('focus', () => {
      this.showParagraph = false;
    });
  
 
    q.root.addEventListener('blur', () => {
      const content = q.getText().trim();
      this.showParagraph = content === ''; 
      this.editorEnabled =
        !!this.editorState.characters || q.root.innerHTML !== '<p><br></p>';
    });
  
  
    q.root.addEventListener('paste', () => {
      q.root.querySelectorAll('img').forEach((img) => img.remove());
      q.root
        .querySelectorAll('[style]')
        .forEach((el) => el.removeAttribute('style'));
    });
  }
  computeWordsAndCharactersCount() {
    const editorText = this.quillEditor.getText().trim();
    const words = editorText.length ? editorText.split(/\s+/) : [];

    this.editorState.words = words.length;
    this.editorState.characters = editorText.length;
  }

  computeWordsAndCharactersCountForRewrite() {
    const text = document.getElementById('HTPD2M2708').innerText;

    this.editorState.res_words = text
      .trim()
      .split(/\s+/)
      .filter((word) => word.length > 0).length;
    this.editorState.res_characters = text.length;
  }

  renderEditor() {
    this.editorEnabled = true;

    this.quillEditor.root.focus();
  }

  f(number: number): string {
    return number.toLocaleString();
  }

  switchLanguage(event) {
    const el = (event.target as HTMLElement).closest('li');

    if (!el) return;

    const language = el.getAttribute('data-language');
    this.selectedLanguage = language;
    this.openMenu.style.display = 'none';

    this.iconRequireReattachment = true;
    setTimeout(() => {
      this.iconRequireReattachment = false;
    });
  }

  handleClickOutside = (event: Event) => {
    if (this.openMenu && !this.openMenu.contains(event.target as Node)) {
      this.openMenu.style.display = 'none';
      this.openMenu = null;
    }

    if (this.popup.content.length) {
      if (
        !(
          this.popup.el === event.target ||
          !!(event.target as HTMLElement).closest('.popup')
        )
      )
        this.dismissPopup();
    }
  };

  toggleReportMenu(event: Event) {
    event.stopPropagation();

    const target = (event.target as HTMLElement).closest('button')
      ?.nextElementSibling as HTMLUListElement;

    if (!target) return;

    if (this.openMenu && this.openMenu !== target) {
      this.openMenu.style.display = 'none';
    }

    target.style.display = target.style.display === 'block' ? 'none' : 'block';
    this.openMenu = target.style.display === 'block' ? target : null;
  }

  copyToClipboard() {
    navigator.clipboard.writeText(
      (document.querySelector('#HTPD2M2708') as HTMLElement).innerText
    );
  }

  clearEditor() {
    this.quillEditor.setText(null);
    this.editorState.words = 0;
    this.editorState.characters = 0;
    this.editorState.response = null;
    this.editorState.res_characters = 0;
    this.editorState.res_words = 0;
    this.editorEnabled = false;
    this.showParagraph = true;
    this.loaderAlert = false;

    this.articleRequestSignal$.next();
    this.editorState.state = 'initial';
    const resultDiv = document.getElementById('editor2');
    if (this.gotresponse) {
      this.gotresponse = false;
    }

    if (resultDiv) {
      resultDiv.innerHTML = '';
      const imgElement = document.createElement('img');
      imgElement.src =
        '../../assets/images/article-rewriter/result-section.png';
      imgElement.className = 'result-section-img';
      imgElement.style.position = 'absolute';
      imgElement.style.top = '45%';
      imgElement.style.left = '49%';
      imgElement.style.textAlign = 'center';
      imgElement.style.transform = 'translate(-50%, -50%)';
      imgElement.style.display = 'block';
      resultDiv.appendChild(imgElement);
    }

    this.saveEditorText();
  }

  saveEditorText() {
    const content = this.quillEditor.root.innerHTML;

    this.apiDataService
      .auto_saved_Api(
        localStorage.getItem('profile_id') || '1',
        'Article Rewriter',
        'Article Rewriter',
        content,
        this.doc_id,
        'article-rewriter'
      )
      .subscribe();
  }

  onResultsClick(event: Event) {
    const target = event.target as HTMLElement;

    if (target.className !== 'words') return;

    this.popup.el = target;

    const words = target.dataset['synonyms'];
    this.popup.content = words.split(';');

    const verticalMargin = 20;
    const horizontalMargin = 15;
    const estimatedPopupWidth = 360;
    const estimatedPopupHeight = 120;

    const parent = (event.currentTarget as HTMLElement).getBoundingClientRect();
    const rect = target.getBoundingClientRect();

    const editorWidth = parent.width;
    const spaceBelow = window.innerHeight - rect.bottom;
    const spaceAbove = rect.top;

    const placeAbove =
      spaceBelow < estimatedPopupHeight && spaceAbove > estimatedPopupHeight;

    let left = rect.left - parent.left;

    if (left + estimatedPopupWidth + horizontalMargin > editorWidth) {
      left = editorWidth - estimatedPopupWidth - horizontalMargin;
    } else if (left < horizontalMargin) {
      left = horizontalMargin;
    }

    let top = placeAbove
      ? rect.top - parent.top - estimatedPopupHeight - verticalMargin
      : rect.bottom - parent.top + verticalMargin;

    this.popup = {
      ...this.popup,
      x: left,
      y: top,
    };
  }

  handlePopupClick(event: Event) {
    const target = (event.target as HTMLElement).closest('button');

    const replacement = target.dataset['replacement']
      ? target.dataset['replacement']
      : (target.previousElementSibling as HTMLInputElement).value;

    if (!replacement.length) return;

    this.popup.el.innerText = replacement;

    (
      document.getElementById('popup-replacement-input') as HTMLInputElement
    ).value = '';

    this.popup.content = [];
    this.popup.el = null;

    setTimeout(() => {
      this.computeWordsAndCharactersCountForRewrite();
    }, 0);
  }

  dismissPopup() {
    this.popup.content = [];
    this.popup.el = null;
  }

  invokeModal(event: Event) {
    const targetId = (event.target as HTMLElement).closest('button').dataset[
      'target'
    ];

    document.getElementById(targetId).style.display = 'grid';
  }

  dismissModal(event: Event) {
    (
      (event.target as HTMLElement).closest('.wrapper') as HTMLElement
    ).style.display = 'none';
  }

  // old component code
  selectedTab: string = 'tab1';
  activeTab: string = '';
  captchaVisible: boolean = false;
  isCaptchaVerified: boolean = false;
  recaptchaMessage: string = '';
  captchaToken: string | null = null;
  public color: string = 'black';
  error: boolean = false;
  success: boolean = false;
  errorAlerts;
  successAlert;
  dangerAlerts;
  got_recpatcha: boolean = false;
  recaptcha_message = '';
  public loaderAlert: boolean = false;
  public copiedtext: boolean = false;
  public gotresponse: boolean = false;
  showParagraph: boolean = true;
  editorTxt: any;
  subscribed_user: boolean = false;
  isUserLoggedin: boolean = false;
  public spanwords = [];
  quill: Quill | undefined;
  public copried_txt: string = '';
  editorTxtAI: string;

  selectTab(tab: string): void {
    this.selectedTab = tab;
  }
  toggleTab(tabId: string): void {
    if (this.activeTab === tabId) {
      this.activeTab = '';
    } else {
      this.activeTab = tabId;
    }
  }
  @ViewChild('mm', { static: true }) mmRef!: ElementRef;
  ngOnInit(): void {
    if (this.captchaVisible) {
      this.loadAndRenderTurnstile();
    }
    this.metaService.updateTags(
      'Article Rewriter Tool | Accurate Article & Essay Rewriter',
      "Grammarin's article rewriter tool uses advanced AI that helps to rewrite articles & paragraphs. Use this article spinner to create unique content with ease.",
      'https://www.grammarin.com/article-rewriter',
      'https://www.grammarin.com/assets/images/OG-Images/Article Rewriter.png',
      'Article Rewriter'
    );
    this.activeTab = 'q5';
   
//  mobile view design tabs 
    const tabs = document.getElementById('icetab-container')!.children;
    const tabcontents = document.getElementById('icetab-content')!.children;
    
    const myFunction = function(this: HTMLElement) {
      const tabchange = (this as any).mynum;
      for (let int = 0; int < tabcontents.length; int++) {
        tabcontents[int].className = 'tabcontent';
        tabs[int].className = 'icetab';
      }
      tabcontents[tabchange].classList.add('tab-active');
      this.classList.add('current-tab');
    };
    
    for (let index = 0; index < tabs.length; index++) {
      const tab = tabs[index] as HTMLElement & { mynum: number };
      tab.mynum = index;
      tab.addEventListener('click', myFunction, false);
    }
//  mobile view design tabs 
  }
  

  handleButtonClick(): void {
    if (this.loaderAlert) {
      return;
    }
    $('#mm').find('span').contents().unwrap();
    this.editorState.characters = $('#mm').text().length;
    this.editorState.words = $('#mm').text().trim().split(/\s+/).length;

    if (this.authState === 'auth')
      if (this.editorState.words >= 15 && this.editorState.words <= 1000) {
        this.showCaptchaModal();
      } else {
        this.showAlert('Enter 15 to 1000  words to check the Article.', '');
      }
    else if (this.authState === 'pro')
      if (this.editorState.words >= 15 && this.editorState.words <= 10000) {
        this.showCaptchaModal();
      } else {
        this.showAlert('Enter 15 to 10,000  words to check the Article.', '');
      }
  }

  showCaptchaModal(): void {
    if (!this.captchaVisible) {
      this.captchaVisible = true;
      this.cdr.detectChanges();
      this.loadAndRenderTurnstile();
    } else {
      this.recaptchaMessage = 'Please complete the CAPTCHA.';
      this.color = '#721c24';
    }
  }

  loadAndRenderTurnstile(): void {
    if (typeof window['turnstile'] === 'undefined') {
      const script = document.createElement('script');
      script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js';
      script.async = true;
      script.defer = true;
      script.onload = () => this.renderTurnstile();
      script.onerror = () =>
        //  console.error('Failed to load Turnstile script.');
        document.body.appendChild(script);
    } else {
      this.renderTurnstile();
    }
  }

  renderTurnstile(): void {
    const containerElement = document.getElementById('recaptcha-container');
    if (!containerElement) {
      return;
    }

    window['turnstile'].render(containerElement, {
      sitekey: environment.CaptchaKey,
      size: 'normal',
      callback: (token: string) => this.onTurnstileSuccess(token),
      'error-callback': () => this.onTurnstileError(),
    });
  }

  onTurnstileSuccess(token: string): void {
    this.captchaToken = token;
    this.isCaptchaVerified = true;
    this.captchaVisible = false;
    this.recaptchaMessage = '';
    this.articleWriter();
  }

  onTurnstileError(): void {
    // console.error('Turnstile error occurred.');
    this.captchaToken = null;
    this.recaptchaMessage = 'CAPTCHA verification failed. Please try again.';
    this.color = '#721c24';
  }

  resetTurnstile(): void {
    const containerElement = document.getElementById('recaptcha-container');
    if (typeof window['turnstile'] !== 'undefined') {
      window['turnstile'].reset(containerElement);
    } else {
    }
  }
  articleWriter() {
    if (!this.isCaptchaVerified) {
      return;
    }
    const editorContent = $('#mm').text().trim();
    // this.editorTxt = editorContent
    // $('#mm').html(this.editorTxt);
    this.loaderAlert = true;
    if (window.innerWidth > 868) {
      let data2 = JSON.stringify({
        homeText: editorContent,
        profile_id: this.profile_id || '1',
      });

      let url = environment.API_URL + '/api/getNewDocIDForGuestByContents';

      this.apiDataService.postResources(data2, url).subscribe((data) => {
        let receivedData = data;

        localStorage.setItem('editorValueAI', editorContent);
        this.doc_id = receivedData['new_doc_id'];

        this.router.navigate(['/article'], {
          queryParams: { doc: this.doc_id },
        });

        const url = this.router.serializeUrl(this.router.createUrlTree(['']));
      });
      return;
    }
    this.apiDataService
      .articleapi(this.quillEditor.getText(), this.articleRequestSignal$)
      .subscribe((data) => {
        $('#mm').html(this.editorTxt);
        this.showParagraph = false;
        this.editorState.response = data['updated_content'];
        if (this.editorState.response) {
          this.gotresponse = true;
          $('#editor2').html(this.editorState.response);
          document
            .getElementById('editor2')
            .setAttribute('contenteditable', 'false');
          this.loaderAlert = false;
        }
        var editorSpan = document.getElementById('editor2');
        const spans = Array.from(editorSpan.querySelectorAll('span'));
        spans.forEach((span) => {
          span.style.color = '#01AA8E';
          span.style.cursor = 'pointer';
        });
      });

    // if (this.authState === 'auth') {
    //   this.showAlert('Enter 15 to 1000  words to check the Article.', '');
    // } else if (this.authState === 'pro') {
    //   this.showAlert('Enter 15 to 10,000  words to check the Article.', '');
    // }
  }

  shouldShowButton: boolean = false;
  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (window.pageYOffset > 200) {
      this.shouldShowButton = true;
    } else {
      this.shouldShowButton = false;
    }
  }

  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
  showAlert(message, selector) {
    this.errorAlerts = message;
    $(selector).css('border-color', 'red');
    this.error = true;
    $('#errorAlerts').show();
    setTimeout(() => {
      $('#errorAlerts').hide();
      $(selector).css('border-color', '#e7e7ec');
      this.error = false;
    }, 4000);
  }
  closeErrorDiv() {
    this.error = false;
  }
  //  objects objects objects

  executeAction(action: string) {
    if (this[action] && typeof this[action] === 'function') {
      this[action]();
    } else {
    }
  }

  contentArray = [
    {
      showParagraph: true,
      header: 'Upload Your Content',
      paragraph: 'Type or Paste AI Text here',
      buttons: [
        {
          text: 'Sample Text',
          icon: 'copyIcon',
          action: 'sampletext',
        },
        {
          text: 'Paste Text',
          icon: 'copyIcon',
          action: 'pasteText',
        },
      ],
    },
  ];
  sampletext() {
    $('#mm').html(
      "We all are aware of the fact that plagiarism can destroy our careers and websites' credibility. Suppose you have detected that some proportion of your text is plagiarized. In that case, you can opt to use the best article rewriter to make your plagiarized sentences and display their plagiarism-free version in a matter of seconds. It means that it's not only wasted an hour or more trying to rewrite plagiarism from the text yourself and then putting to some responsibility for both of these demanding jobs and providing you 100% unique content in the blink of an eye. There is plagiarism, but only some platforms will provide you with the quality Grammarin offers. This article is jam-packed with top-notch features to facilitate you in the best way possible. You can enjoy the following features."
    );
    this.editorState.characters = this.quillEditor.getText().trim().length;
    this.editorState.words = this.quillEditor;
    this.showParagraph = false;
    this.loaderAlert = false;
  }

  pasteText(): void {
    navigator.clipboard
      .readText()
      .then((pastedText) => {
        document.execCommand('insertText', false, pastedText);
        $('#mm').html(pastedText);
        this.editorState.characters = $('#mm').text().length;
        this.editorState.words = $('#mm').text().trim().split(' ').length;
        this.showParagraph = false;
      })
      .catch((err) => {
        // console.error('Failed to read clipboard contents: ', err);
      });
  }

  count_Words_Character2() {
    this.editorState.characters = this.quillEditor.getText().trim().length;
    this.editorState.words = this.quillEditor
      .getText()
      .trim()
      .split(/\s+/)
      .filter((word) => word.length > 0).length;
    this.editorState.characters = $('.ql-editor').text().length;
    this.editorState.words = $('.ql-editor').text().split(/\s+/).length;
  }
  downloadText() {
    const editorElement = $('#editor2').get(0);
    if (editorElement) {
      this.loaderAlert = true;
      const textContent = editorElement.innerText;
      const blob = new Blob([textContent], { type: 'text/plain' });
      const a = document.createElement('a');
      const url = window.URL.createObjectURL(blob);
      a.href = url;
      a.download = 'text_file.txt';
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    }
    this.loaderAlert = false;
  }

  copyText() {
    const editorElement = $('#editor2').get(0);
    if (editorElement) {
      const range = document.createRange();
      range.selectNode(editorElement);
      window.getSelection()?.removeAllRanges();
      window.getSelection()?.addRange(range);
      try {
        document.execCommand('copy');
        this.copiedtext = true;
        this.copried_txt = 'copied';
        $('#copytextId').hide();
        $('#copried_txt').show();
        setTimeout(function () {
          $('#copried_txt').hide();
          $('#copytextId').show();
          this.copiedtext = false;
        }, 2000);
      } catch (err) {
        this.copiedtext = false;
      }
      window.getSelection()?.removeAllRanges();
    }
  }


  //********loader on upload file ***** */
  onUploadStart() {
    this.loaderAlert = true;
    this.showParagraph = false;
  }

  onUploadFinish() {
    this.loaderAlert = false;
  }
  //********loader on upload file ***** */
 
  // show/ hide  main quill div and mobile qill div 

  activesction: 'input' | 'output' = 'input';
  screenWidth: number = window.innerWidth;
  
  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    const windowObj = event.target as Window;
    this.screenWidth = windowObj.innerWidth;
  }
  
  // show/ hide  main quill div and mobile qill div 
}
